import type { InfoCardProps } from "@components/InfoCardProps.js";
import type { Tenant } from "@core/schema/Tenant.js";

export function getReasonsIntegrations(tenant: Tenant): InfoCardProps[] {
	return [
		{
			title: "Zbytečná manuální práce",
			desc: "Proč zadávat do každého systému či aplikace data ručně? Integrací tyto a podobné procesy zautomatizujete.",
		},
		{
			title: "Chaotická rozhodnutí",
			desc: "Pokud jsou v některých systémech neaktuální data, nemůžete udělat správná byznysová rozhodnutí.",
		},

		{
			title: "Vysoká chybovost",
			desc: "Při ručním zadáváním dat dřív nebo později nasekáte chyby. Propojením systémů se tomu z velké části vyhnete.",
		},
		{
			title: "Přehlcení systémy a nástroji",
			desc: "Pomůžeme vám skoncovat s neustálým překlikáváním mezi různými systémy a tabulkami. Vše budete mít na jednom místě.",
		},
	];
}
